/* eslint no-param-reassign: 0 */
import { ImageService } from '../services/image.service';

const uploadState = {
  uploading: false,
  key: 0,
};

const mutations = {
  uploading(state, bool) {
    state.uploading = bool;
  },
  uploadingKey(state) {
    state.key += 1;
  },
};

const getters = {
  uploading: state => state.uploading,
  key: state => state.key,
};

const actions = {
  uploading({ commit }, bool) {
    commit('uploading', bool);
  },
  // eslint-disable-next-line
  async uploadImages({}, payload) {
    try {
      const images = await ImageService.uploadImages(payload);
      return images;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: uploadState,
  mutations,
  getters,
  actions,
};
